import { render, staticRenderFns } from "./customRightIcon.vue?vue&type=template&id=c2c8f896&scoped=true&"
import script from "./customRightIcon.vue?vue&type=script&lang=js&"
export * from "./customRightIcon.vue?vue&type=script&lang=js&"
import style0 from "./customRightIcon.vue?vue&type=style&index=0&id=c2c8f896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8f896",
  null
  
)

export default component.exports